import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useRef, useState } from 'react';

export type TUseControlledParams<S> = {
    controlled: S;
    default: S | (() => S);
};

export type TUseControlledFunc<S> = (
    params: TUseControlledParams<S>
) => [S, Dispatch<SetStateAction<S>>];

export const useControlled = <S>({
    controlled,
    default: defaultProp,
}: TUseControlledParams<S>): [S, Dispatch<SetStateAction<S>>] => {
    const isControlled = useRef(controlled !== undefined);
    const [valueState, setValue] = useState(defaultProp);
    const value = isControlled.current ? controlled : valueState;
    const setValueIfUncontrolled = useCallback((newValue: SetStateAction<S>) => {
        if (!isControlled.current) {
            setValue(newValue);
        }
    }, []);

    return [value, setValueIfUncontrolled];
};
